<div class="pm-form-field-phone">
  <p-select
    [options]="filteredCountries"
    [(ngModel)]="selectedCountry"
    (ngModelChange)="onSelectedCountryChange()"
    i18n-placeholder
    placeholder="Kraj"
    [filter]="true"
    class="pm-phone-number-dial-dropdown"
  >
    <ng-template pTemplate="filter" let-options="filteredCountries">
      <div class="flex gap-1 filter-container">
        <div
          class="p-inputgroup"
          (click)="$event.stopPropagation()"
          (keyup.enter)="$event.stopPropagation()"
          role="presentation"
        >
          <pm-form-field-text [ctrl]="filterCtrl" [formField]="filterConfig" />
        </div>

        <pm-button
          *ngIf="filterCtrl?.value"
          icon="close"
          [type]="PMButtonTypeEnum.SECONDARY"
          (clickEvent)="resetFunction()"
        />
      </div>
    </ng-template>
    <ng-template pTemplate="selectedItem">
      <div class="flex align-items-center gap-2" *ngIf="selectedCountry">
        <img
          src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
          [class]="'flag flag-' + selectedCountry?.code?.toLowerCase()"
          style="width: 18px"
          alt="flag"
        />
        <div>
          {{ selectedCountry.dial_code }}
        </div>
      </div>
    </ng-template>
    <ng-template let-country pTemplate="item">
      <div class="flex align-items-center gap-2">
        <img
          src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
          [class]="'flag flag-' + country?.code?.toLowerCase()"
          style="width: 18px"
          alt="flag"
        />
        <div>({{ country.dial_code }})&nbsp;{{ getTranslation(country.names) }}</div>
      </div>
    </ng-template>
  </p-select>
  <pm-form-field-number
    [ctrl]="phoneCtrl"
    [formField]="phoneConfig"
    class="pm-phone-number-input"
    [ngClass]="{ 'ng-invalid ng-dirty ng-touched': ctrl.invalid }"
    #phoneNumberInput
  />
</div>
